
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 15.637a5 5 0 100-10 5 5 0 000 10z","stroke":"#000C1F","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M7.462 11.406c.384 1.385 1.923 2.231 3.307 1.846.847-.307 1.539-1 1.77-1.846M8.308 9.406a.154.154 0 110-.308","stroke":"#000C1F","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8.308 8.806a.6.6 0 000 1.2v-1.2zm0-.308a.6.6 0 000 1.2v-1.2zm0 1.508a.754.754 0 00.753-.754h-1.2c0-.246.2-.446.447-.446v1.2zm.753-.754a.754.754 0 00-.753-.754v1.2a.446.446 0 01-.447-.446h1.2z","fill":"#000C1F"}}),_c('path',{attrs:{"d":"M11.692 9.406a.154.154 0 010-.308","stroke":"#000C1F","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M11.692 8.806a.6.6 0 100 1.2v-1.2zm0-.308a.6.6 0 100 1.2v-1.2zm0 1.508a.754.754 0 00.754-.754h-1.2c0-.246.2-.446.446-.446v1.2zm.754-.754a.754.754 0 00-.754-.754v1.2a.446.446 0 01-.446-.446h1.2z","fill":"#000C1F"}})])
          )
        }
      }
    